export default __webpack_public_path__ + "static/media/hotel-key-card-system-ss.698f894a.jpg";